import React, { useEffect, useState, useMemo } from "react";
import get from "lodash.get";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { dropdownTypes, states } from "../Reports/values/enums";
import creators from "../Reports/state/roster/creators";
import Dropdown from "../Global/Dropdown";
import { useSelector } from "react-redux";
import { selectAlertsData } from "@/store/slices";
import { AlertType } from "@/enums/Alerts";
import '@/components/Global/AlertPip/AlertPip.scss';
import './SelectClassroom.scss';
import { AlertUrgency } from "@/enums/Alerts";

// FOUND IN STUDENT SEARCH
const SelectClassroom = ({
  selectedClass,
  rosterSelect,
  classrooms,
  rosterStatus,
  school
}) => {
  const { t } = useTranslation();
  const { allAlerts = [] } = useSelector(selectAlertsData) || {};
  const isLoading = rosterStatus === states.PENDING || classrooms?.length < 1;
  
  // Find other classrooms (not selected) that have alerts and exist in the user's classrooms list
  // allAlerts is an array of dictonary entries, where the classroom id is the key, and the value is an array of alert objects that have attentionLevel properties to check
  // Memoize the computation so it updates only when dependencies change
  const otherClassroomAlertEntries = useMemo(
    () =>
      Object.entries(allAlerts).filter(
        ([classroomId, alerts]) =>
          Number(classroomId) !== selectedClass?.id &&
          classrooms.some(c => c.id === Number(classroomId))
      ),
    [allAlerts, selectedClass, classrooms]
  );

  const handleRosterChange = (data) => {
    //if we selected the same classroom twice in a row, do nothing
    if (selectedClass && selectedClass.id === data.value) {
      return;
    }

    //Transform the selection to fit the object model to match the Miller Control.
    //TODO: use the Miller Control in Assignment Selection -OR- move this transform down to the rosterSelect method.
    let rosterData = JSON.parse(JSON.stringify(data));
    rosterData.ui = data;
    rosterData.id = data.value;

    rosterSelect({
      type: "classroom",
      data: rosterData,
    });
  };

  return (
    <div
      data-testid="aec-select-classroom"
      className="aec-select-classroom d-flex flex-column position-relative"
    >
      {classrooms && (
        <Dropdown
          placeholder={isLoading ? t("loading") : t("select_classroom")}
          value={isLoading ? t("loading") : selectedClass}
          options={classrooms.map((classroom) => classroom.ui)}
          onChange={(data) => handleRosterChange(data)}
          type={dropdownTypes.PRIMARY}
          isLoading={isLoading}
          entityLabel={isLoading ? t("loading") : school.label}
          ariaLabel={isLoading ? t("loading") : `${t("select_classroom")} (${school.label})`}
        />
      )}
      {classrooms && classrooms.length > 1 && otherClassroomAlertEntries.length > 0 && (
        <div className="pip-wrapper">
          <div className={`alert-pip dot ${
          otherClassroomAlertEntries.some(
            ([_, alerts]) => alerts.some(a => a.attentionLevel === AlertUrgency.Urgent) 
          ) ? "urgent" : ""
        }`}></div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ reports }) => {
  const { roster } = reports;

  return {
    classrooms: roster.data ? roster.data.classroom : [],
    selectedClass: roster.ui ? roster.ui.selections.classroom : null,
    rosterStatus: get(roster, "status.type"),
    school: roster.ui ? roster.ui.selections.school : null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  rosterSelect: (selection) => dispatch(creators.rosterSelect(selection)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectClassroom);
